import { useDismiss, useInteractions } from '@floating-ui/react';
import {
  UploadImage,
  UploadResults,
} from 'articleEditor/components/blocks/imageBlock/uploadImage';
import { UploadMenu } from 'articleEditor/components/uploadMenu';
import usePointHover from 'articleEditor/hooks/usePointHover';
import { focusEditor } from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { BasePoint } from 'lib-knowledge-document-structure/slate/package';
import { useCallback } from 'react';
import { useSnapshot } from 'valtio';

import { inlineImageActions, inlineImageState } from './inlineImage.store';

export function InlineImageMenu(): JSX.Element {
  const { point } = useSnapshot(inlineImageState);
  if (!point) return <></>;

  return <InlineImageFloating point={point as BasePoint} />;
}

type InlineImageFloatingProps = {
  point: BasePoint;
};
function InlineImageFloating({ point }: InlineImageFloatingProps) {
  const editor = useMyEditorRef();

  const onUpload = useCallback(
    (results: UploadResults) => {
      inlineImageActions.insert({
        url: results.url,
        width: results.width,
        height: results.height,
        editor,
      });

      setTimeout(() => {
        focusEditor(editor, editor.selection!);
      }, 50);
    },
    [editor],
  );
  const floatingProps = usePointHover({
    point,
    floatingDivId: 'inlineImageMenu',
    onOpenChange: (isOpen) => {
      if (!isOpen) inlineImageActions.hide();
    },
  });

  const context = floatingProps.context;
  const { getFloatingProps } = useInteractions([useDismiss(context)]);

  return (
    <UploadMenu
      id="inlineImageMenu"
      floatingProps={floatingProps}
      getFloatingProps={getFloatingProps}
    >
      {/* TODO: move this file to somewhere shared */}
      <UploadImage onUpload={onUpload} />
    </UploadMenu>
  );
}
